/** @format */

import axios from 'axios';
import { CallLog, CallLogsFilterInput, CallLogUpdateInput } from '../types/callLogs.types';

const apiUrl = process.env.REACT_APP_SIADASH_BACKEND_URL;

/**
 * Get call logs with optional filtering
 * Supports filtering by officeId, userId, agentName, vendorName, queueId, date range, Billable, and statusName
 */
export const getCallLogs = async (filter?: CallLogsFilterInput): Promise<CallLog[]> => {
  const token = localStorage.getItem('accessToken');
  console.log('Fetching call logs with filter:', filter);
  const response = await axios.get(`${apiUrl}/api/call-logs`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: filter,
  });
  console.log('Call logs fetched:', response.data);
  return response.data;
};

/**
 * Get call log by ID
 */
export const getCallLogById = async (id: string): Promise<CallLog> => {
  const token = localStorage.getItem('accessToken');
  const response = await axios.get(`${apiUrl}/api/call-logs/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

/**
 * Update a call log
 */
export const updateCallLog = async (id: string, updates: CallLogUpdateInput): Promise<any> => {
  const token = localStorage.getItem('accessToken');
  console.log('Updating call log:', id, updates);
  const response = await axios.put(`${apiUrl}/api/call-logs/${id}`, updates, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  console.log('Call log updated:', response.data);
  return response.data;
};
